var map = {
	"./de.png": 1049,
	"./en.png": 1050,
	"./es.png": 1051,
	"./fr.png": 1052,
	"./ja.png": 1053,
	"./mk.png": 1054,
	"./pt.png": 1055,
	"./tr.png": 1056,
	"./zh.png": 1057
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1048;


//////////////////
// WEBPACK FOOTER
// ./src/portal/components/language-switcher/flags ^\.\/.*\.png$
// module id = 1048
// module chunks = 0